import * as React from 'react';
import { CheckBoxWithLabelProps } from './CheckBoxWithLabelWidget';
import { CheckBoxWithLabelWidget } from './SelectorShims';
import { DivAttrs } from '../../utils/HtmlAttrs';

export interface CheckBoxWithLabelGroupProps extends Required<Pick<DivAttrs, 'aria-labelledby'>> {
  /** @deprecated instead use `children` */
  checkBoxWithLabelPropsList?: CheckBoxWithLabelProps[];

  children?: Array<React.ReactElement<CheckBoxWithLabelWidget['props']>>;
}

/**
 * This Widget should be used *only* if the list of checkboxes forms a logical group with a visible label.
 * See https://www.w3.org/TR/wai-aria-practices-1.1/#checkbox
 */
// tslint:disable-next-line:max-line-length
export class CheckBoxWithLabelGroupWidget extends React.PureComponent<CheckBoxWithLabelGroupProps & Omit<DivAttrs, 'aria-labelledby' | 'role'>> {
  public render(): JSX.Element {
    // tslint:disable-next-line:deprecation
    const { checkBoxWithLabelPropsList, children, ...divProps } = this.props;
    return <div role='group' {...divProps}>
      {children || checkBoxWithLabelPropsList?.map((props, index) => <CheckBoxWithLabelWidget {...props} key={index} />)}
    </div>;
  }
}
